import * as React from 'react';
import { Button } from '../../core/components/Button.js';
import { hydrate } from '../../core/components/hydrate.js';

interface CopyPromptButtonProps {
    text: string;
}

export const CopyPromptButton: React.FC<CopyPromptButtonProps> & { ScriptName: string; URLPath: string } = ({
    text,
}) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = async () => {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Button variant="secondary" size="xs" onClick={handleCopy}>
            {copied ? 'Copied!' : 'Copy'}
        </Button>
    );
};

CopyPromptButton.ScriptName = 'CopyPromptButton';
CopyPromptButton.URLPath = 'home/components/CopyPromptButton';
hydrate(CopyPromptButton);
